module.exports = __webpack_public_path__ + "static/img_2001-912f312b10a9f900e4af9636fa45438c.webp";